import React from 'react';
import { List, ListItem, IconButton, CircularProgress } from 'material-ui';
import NavigationClose from 'material-ui/svg-icons/navigation/close';

/**
 * @param {{
 *  areas: Array,
 *  allAreas: Array,
 *  onAreaClick: Function,
 *  onRemoveClick: Function,
 *  emptyText: string,
 * }} param0 
 */
function AreaList({ areas, allAreas, onAreaClick, onRemoveClick, emptyText }) {
    if (!!areas && areas.length === 0) {
        return <div style={{ color: '#888', fontSize: 'smaller', textAlign: 'center' }}>
            {emptyText}
        </div>;
    }
    if (!areas) {
        return <div style={{ textAlign: 'center' }}>
            <CircularProgress size={16} thickness={2} />
        </div>;
    }
    return <List>
        {areas.map((area, index) => {
            const parentCount = (area.parents || [])
                .map(id => allAreas.find(a => a._id === id))
                .reduce((count, area) => area ? count + 1 : count, 0);
            return <ListItem 
                // use index for key, not date, because date is invoked once, resulting in similar keys => if you have 
                // an area that is the child of two different areas => error and parent tree is displayed wrong
                key={area._id + index}
                primaryText={area.name}
                secondaryText={
                    <div style={{ fontSize: 'smaller' }}>
                        <b style={{ color: parentCount > 1 ? 'rgb(255, 64, 129)' : '' }}>
                            {parentCount}
                        </b>
                        {parentCount === 1 ? ' parent ' : ' parents '}
                        <b>{area.childAreaCount}</b>
                        {area.childAreaCount === 1 ? ' child ' : ' children '}
                        <b>{area.childPortCount}</b>
                        {area.childPortCount === 1 ? ' port' : ' ports'}
                    </div>
                }
                rightIconButton={
                    <IconButton onClick={() => onRemoveClick(area._id)}>
                        <NavigationClose />
                    </IconButton>
                }
                onClick={() => onAreaClick(area._id)}
                initiallyOpen
                style={{ fontSize: '12px !important' }}
            />;
        })}
    </List>;
}

export default React.memo(AreaList);



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Areas/AreaList.jsx